angular.module('mercury.modules.stock.statement')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.StatementAdd', {
    url: '/statement/add/:supplierId?report',
    controller: 'StockStatementEditCtrl',
    templateUrl: 'modules/stock/statement/edit.tpl.html',
    data: {
      menuLinkState: 'Stock.ReportSupplier'
    }
  });

  $stateProvider.state('Stock.StatementEdit', {
    url: '/statement/edit/:statementId?report',
    controller: 'StockStatementEditCtrl',
    templateUrl: 'modules/stock/statement/edit.tpl.html',
    data: {
      menuLinkState: 'Stock.ReportSupplier'
    }
  });

  $stateProvider.state('Stock.StatementEdit.PurchaseOrderEdit', {
    url: '/edit/:id',
    data: {
      menuLinkState: 'Stock.ReportSupplier',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/popupedit.tpl.html',
        controller: 'StockPurchaseorderEditCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StatementAdd.PurchaseOrderEdit', {
    url: '/edit/:id',
    data: {
      menuLinkState: 'Stock.ReportSupplier',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/popupedit.tpl.html',
        controller: 'StockPurchaseorderEditCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StatementEdit.PurchaseOrderAdjustment', {
    url: '/adjustment/?:supplierId&:date',
    data: {
      menuLinkState: 'Stock.ReportSupplier',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/popupedit.tpl.html',
        controller: 'StockPurchaseorderEditCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StatementAdd.PurchaseOrderAdjustment', {
    url: '/adjustment/?:supplierId&:date',
    data: {
      menuLinkState: 'Stock.ReportSupplier',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        templateUrl: 'modules/stock/purchaseorder/popupedit.tpl.html',
        controller: 'StockPurchaseorderEditCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Stock.StatementList', {
    url: '/statement/list/:supplierId?report',
    controller: 'StockStatementListCtrl',
    templateUrl: 'modules/stock/statement/list.tpl.html',
    data: {
      menuLinkState: 'Stock.ReportSupplier'
    }
  });

  $stateProvider.state('Stock.SupplierStatements', {
    url: '/statements?supplierId&supplierName&start&end&dateRange&prevDateRange',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.ReportReceivedInvoices'
    }
  });

  $stateProvider.state('Stock.EditSupplierStatement', {
    url: '/statements/:statementId?supplierId&supplierName&start&end&dateRange&prevDateRange',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.ReportReceivedInvoices'
    }
  });

  $stateProvider.state('Stock.AddSupplierStatement', {
    url: '/statements/add?supplierId&supplierName&start&end&dateRange&prevDateRange',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.ReportReceivedInvoices'
    }
  });

  $stateProvider.state('Stock.AccountingSystemExport', {
    url: '/reports/received-invoices/export?start&end&dateRange&prevDateRange',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.ReportReceivedInvoices'
    }
  });

  $stateProvider.state('Stock.ExportTo', {
    url: '/reports/received-invoices/export-to?start&end&dateRange&prevDateRange&exportType&combine&accountingSystem&supplierIds&supplierStatementIds&invoiceIds&purchaseOrderIds',
    controller: 'ReactCtrl',
    data: {
      menuLinkState: 'Stock.ReportReceivedInvoices'
    }
  });
}]);
